import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  RestrictionsResponseSchema,
  restrictionsSchema,
} from '../shared/schemas/restrictions.js';

export type RestrictionsResponse = z.infer<typeof restrictionsSchema>;

export const getPlanningRestrictionsQueryOptions = defaultClient.query({
  url: `planning-service/meta/planning/restrictions/` as const,
  method: 'GET',
  responseSchema: RestrictionsResponseSchema,
  querySchema: z.object({
    mediaDataId: z.string().optional(),
  }),
  processResponse: (data) => {
    return data.data?.items[0];
  },
  clientOptions: {
    request: {
      snakeCaseQueryParams: true,
    },
  },
});
